import { resolveStoreHref } from "../lib/storePaths";

export default function StoreFooterLinks({ links = [], storeSlug }) {
  const items = (Array.isArray(links) ? links : []).filter(
    (link) => link?.label && link?.href
  );
  if (!items.length) return null;
  return (
    <nav className="store-footer__links" aria-label="Rodapé">
      {items.map((link) => (
        <a
          key={`${link.label}-${link.href}`}
          href={resolveStoreHref(link.href, storeSlug)}
        >
          {link.label}
        </a>
      ))}
    </nav>
  );
}
